/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CopyRubricAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['oldAssignmentId', codecNumber, 'old_assignment_id'],
]);
export class CopyRubricAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CopyRubricAssignmentDataParser.decode(input).map(res => new CopyRubricAssignmentData(res));
    }
    static unsafeDecode(input) {
        return CopyRubricAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CopyRubricAssignmentDataParser.encode(data);
    }
    static schema() {
        return CopyRubricAssignmentDataParser.schema();
    }
}
